import { Skeleton } from '@/shared/components/shadcn'

export function CardTableSkeleton() {
  return (
    <div>
      <div className="flex flex-col space-y-0">
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className="flex items-center justify-between p-3 border-b last:border-b-0"
          >
            <Skeleton className="h-4 w-1/8" />
            <Skeleton className="h-4 w-1/4" />
            <Skeleton className="h-4 w-1/4" />
            <Skeleton className="h-4 w-1/4" />
          </div>
        ))}
      </div>
    </div>
  )
}
